import axios from 'axios';

// API base URL configuration
// Production: uses relative /api path (routes to serverless function)
// Development: set REACT_APP_API_URL in .env.development for localhost
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tsvmap_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('tsvmap_token');
      localStorage.removeItem('tsvmap_user');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) =>
  api.post('/auth/login', { email, password });

export const getCurrentUser = () =>
  api.get('/auth/me');

export const changePassword = (currentPassword, newPassword) =>
  api.put('/auth/password', { currentPassword, newPassword });

// Organizations
export const getOrganizations = () =>
  api.get('/organizations');

export const getOrganization = (id) =>
  api.get(`/organizations/${id}`);

export const createOrganization = (data) =>
  api.post('/organizations', data);

export const updateOrganization = (id, data) =>
  api.put(`/organizations/${id}`, data);

export const deleteOrganization = (id) =>
  api.delete(`/organizations/${id}`);

// Job Roles
export const getJobRoles = (organizationId) =>
  api.get('/job-roles', { params: { organization_id: organizationId } });

export const getJobRole = (id) =>
  api.get(`/job-roles/${id}`);

export const createJobRole = (data) =>
  api.post('/job-roles', data);

export const updateJobRole = (id, data) =>
  api.put(`/job-roles/${id}`, data);

export const deleteJobRole = (id) =>
  api.delete(`/job-roles/${id}`);

// Assessment Links
export const getAssessmentLinks = (params) =>
  api.get('/assessment-links', { params });

export const getPublicAssessmentLink = (uuid) =>
  api.get(`/assessment-links/public/${uuid}`);

export const getAssessmentLink = (id) =>
  api.get(`/assessment-links/${id}`);

export const createAssessmentLink = (data) =>
  api.post('/assessment-links', data);

export const updateAssessmentLink = (id, data) =>
  api.put(`/assessment-links/${id}`, data);

export const deleteAssessmentLink = (id) =>
  api.delete(`/assessment-links/${id}`);

// Assessments
export const getAssessments = (params) =>
  api.get('/assessments', { params });

export const getAssessment = (id) =>
  api.get(`/assessments/${id}`);

export const getAssessmentQuestions = () =>
  api.get('/assessments/questions');

export const getDISCQuestions = () =>
  api.get('/assessments/questions');

export const startAssessment = (data) =>
  api.post('/assessments/start', data);

export const submitAssessment = (uuid, answers) =>
  api.post(`/assessments/submit/${uuid}`, { answers });

export const getAssessmentResults = (uuid) =>
  api.get(`/assessments/results/${uuid}`);

export const deleteAssessment = (id) =>
  api.delete(`/assessments/${id}`);

export default api;
